import './PickerInfoBox.css';
import * as React from "react";
import PropTypes from "prop-types";

WarningBox.propTypes = {
    warning: PropTypes.string,
    sticky: PropTypes.bool
}

export default function WarningBox(props) {
    if (props.warning == null) {
        return null;
    }

    const warning = <span className="picker-box-warning only-one">{props.warning}</span>;

    return (
        <>
            <div className={"info-picker-box " + (props.sticky ? "sticky" : "")}>
                <p>{warning}</p>
            </div>
            {props.sticky
                ? <div className={"info-picker-box placeholder"}>
                    <p>{warning}</p>
                </div>
                : null
            }
        </>
    );
}